import jwtDecode from 'jwt-decode'
import api from '../../services/api'

export const namespaced = true

export const state = {
  user: null
}

export const mutations = {
  SET_USER_DATA(state, userData) {
    state.user = userData
    localStorage.setItem('user', JSON.stringify(userData))
    localStorage.setItem('token', userData.token)
  },
  CLEAR_USER_DATA() {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    location.reload()
  },
  LOGOUT() {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    window.localStorage.setItem('logout', Date.now())
    //location.reload()
  },
  SET_TOKEN(state, token) {
    let decode = jwtDecode(token)
    let userData = {
      token: token,
      name: decode['sub'],
      id: decode['lrs-id']
    }
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.setItem('token', token)
    state.user = userData
    //commit('SET_USER_DATA', userData)
    localStorage.setItem('user', JSON.stringify(userData))
  }
}

export const actions = {
  userLogin({ commit }, credentials) {
    return api
      .post('xapi/dashboard/login', credentials, {
        crossdomain: true
      })
      .then(({ data }) => {
        commit('SET_USER_DATA', data)
    })
  },
  userlogout({ commit }) {
    commit('LOGOUT')
  }
}

export const getters = {
  loggedIn(state) {
    return !!state.user
  }
}
